import axios from 'axios';
import {isImage, createThreadForm} from '../util/utils';
// import {edgeServer} from '../api_client/apiClient';
// import axios from 'axios';


const url = "https://edge-api.themusio.com/v1/console/upload";

export default function uploadImageCallBack(file) {
  return new Promise(
    (resolve, reject) => {

      if(isImage(file.name)){
        if(file.size<1000000){      //3500000
          axios.get(url)
          .then((response)=>{

            let formData = new FormData();
            let data = response.data.data.post.fields;
            let postURL = response.data.data.post.url;
            let getURL = response.data.data.get;

            formData = createThreadForm(data);
            formData.append('file',file);
            // data includes POST url, and field informations, and GET url
            let token = axios.defaults.headers.common['Authorization'];
            delete axios.defaults.headers.common['Authorization'];

            axios.post(postURL, formData)
            .then((res)=>{
              axios.defaults.headers.common['Authorization'] = token;
              resolve({data:{link:getURL}});
            })
            .catch((err)=>{
              axios.defaults.headers.common['Authorization'] = token;
              reject(err);
            })
          })
          .catch((err)=>{
            // see when error accurs and return the error
            reject(err);
          })
        }

        else{
          alert('file must be smaller than 3mb');
          reject();
        }
      }else{
        alert('Inappropriate file type');
        reject();
      }
    }
  );
}



// WEBPACK FOOTER //
// ./src/util/uploadImageCallBack.js